import { IDENTITY_TYPES } from 'arnConstants';
import { NAME_CHANGE_DOC_TYPES } from 'arnConstants';

/**
 *
 * @param  {string} [documentType] - string value of identity document types
 *
 * @return {object?}  - an object {title: string, identityType: string}
 */
export const getIdentityDocumentTitleAndDataModel = (documentType) => {
  if (!documentType) {
    return null;
  }

  if (documentType === IDENTITY_TYPES.AU_PASSPORT) {
    return { title: 'Australian passport', identityType: 'auPassportDetails' };
  }
  if (documentType === IDENTITY_TYPES.AU_BIRTH_CERTIFICATE) {
    return { title: 'Australian birth certificate', identityType: 'auBirthCertificateDetails' };
  }
  if (documentType === IDENTITY_TYPES.AU_CITIZENSHIP_CERTIFICATE) {
    return { title: 'Australian citizenship certificate', identityType: 'auCitizenshipCertificateDetails' };
  }
  if (documentType === IDENTITY_TYPES.FORIGN_PASSPORT) {
    return { title: 'foreign passport', identityType: 'foreignPassportDetails' };
  }
  if (documentType === IDENTITY_TYPES.IMMI_CARD) {
    return { title: 'ImmiCard', identityType: 'immiCardDetails' };
  }
};

/**
 *
 * @param  {object} personalDetails - personal details
 * @param  {object} identityDetails - identity document details
 *
 * @return {boolean}  - a boolean value true if fullname match otherwise false
 */
export const isFullNameMatch = (personalDetails, identityDetails) => {
  const fullName = personalDetails.otherGivenNames ?
    personalDetails.firstName.trim() + ' ' + personalDetails.otherGivenNames.trim() + ' ' + personalDetails.lastName.trim()
    : personalDetails.firstName.trim() + ' ' + personalDetails.lastName.trim();
  
    const fullLegalName = identityDetails.givenNames.trim() + ' ' + identityDetails.familyName.trim();
  
  return fullLegalName.toLowerCase() === fullName.toLowerCase();
};

/**
 *
 * @param  {string?} [documentType] - string value of name change document types
 *
 * @return {object?}  - an object {title: string, identityType: string}
 */
 export const getNameChangeDocumentTitleAndDataModel = (documentType) => {
  if (!documentType) {
    return null;
  }

  if(documentType === NAME_CHANGE_DOC_TYPES.NAME_CHANGE_CERTIFICATE){
    return { title: 'Australian change of name certificate', identityType: 'changeOfNameCertificateDetails' };
  }
  if(documentType === NAME_CHANGE_DOC_TYPES.MARRIAGE_CERTIFICATE){
    return { title: 'Australian Marriage Certificate', identityType: 'marriageCertificateDetails' };
  }
};

export const getManualPOIPoints = (manualPOIDocuments) => {
  return getManualPOIPointsPrimary(manualPOIDocuments) + getManualPOIPointsSecondary(manualPOIDocuments);
};

export const getManualPOIPointsPrimary = (manualPOIDocuments) => {
  return (manualPOIDocuments?.primaryDocuments70Points?.length ? manualPOIDocuments?.primaryDocuments70Points?.length * 70 : 0) +
  (manualPOIDocuments?.primaryDocuments40Points?.length ? manualPOIDocuments?.primaryDocuments40Points?.length * 40 : 0);
};

export const getManualPOIPointsSecondary = (manualPOIDocuments) => {
  return (manualPOIDocuments?.secondaryDocuments40Points?.length ? manualPOIDocuments?.secondaryDocuments40Points?.length * 40 : 0) +
  (manualPOIDocuments?.secondaryDocuments25Points?.length ? manualPOIDocuments?.secondaryDocuments25Points?.length * 25 : 0);
};